"use client";

import React from "react";
import { MainMenuService } from "./MainMenuService";

export const MainMenuController = (): null =>
{
    React.useLayoutEffect(() =>
    {
        const controllers = Array.from(document.querySelectorAll<HTMLDivElement>("[data-logic-feature='main-menu']")).map(element => new MainMenuService(element));

        return () =>
        {
            controllers.forEach(controller => controller.dispose());
        };
    }, []);

    return null;
}